import 'isomorphic-fetch';
import { Trims } from '../typings/general';

interface FetchCarlinesOptions {
  readonly faServicesUrl: string;
  readonly apiKey: string;
  readonly modelYear: string;
  readonly carline: string;
  readonly serviceConfigsServiceConfig?: string;
}

function createTrimsUrl(params: URLSearchParams, urlOrigin: string): string {
  return `${urlOrigin}/maintenance/trims?${params.toString()}`;
}

export async function fetchTrims({
  faServicesUrl,
  apiKey,
  modelYear,
  carline,
}: FetchCarlinesOptions): Promise<Trims> {
  const params = new URLSearchParams();
  params.set('brand', 'V');
  params.set('importerCode', '444');
  params.set('languageCode', 'en-US');
  params.set('modelYear', modelYear);
  params.set('carline', carline);

  const response = await fetch(createTrimsUrl(params, faServicesUrl), {
    headers: { 'x-api-key': apiKey },
  });

  const trims = await response.json();

  if (response.status >= 400) throw new Error(trims.message);

  return trims;
}
